module.exports = __webpack_public_path__ + "img/rights_vip.660cb6b6.png";